import React, { useState, useEffect } from 'react';
import { Link as ScrollLink, scroller } from 'react-scroll'; // React Scroll-ის ლინკი და ფუნქცია
import { Link as RouterLink, useLocation } from 'react-router-dom'; // React Router-ის ლინკი
import './SidebarMenu.css';
import { useTranslation } from 'react-i18next';
import burgemmenulogo from "../../assets/images/burgemmenulogo.svg";
import downarrow from '../../assets/images/downarrow.svg';
import Panel from './Panel';
import Facebook from '../../assets/images/Facebook.svg';
import Instagram from '../../assets/images/Instagram.svg';
import Phone from '../../assets/images/phone.svg';
import AddressComponent from '../Footer/AddressComponent';
import CallButton from '../Header/callbutton';
import WineryPanel from '../../Winery Products/WineryPanel';

const SidebarMenu = ({ isOpen, toggleMenu }) => {
  const location = useLocation(); 
  const { t } = useTranslation();

  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isWineryPanelOpen, setIsWineryPanelOpen] = useState(false);

  const togglePanel = (panelType) => {
    if (panelType === 'product') {
      setIsPanelOpen(!isPanelOpen);
      setIsWineryPanelOpen(false);
    } else if (panelType === 'winery') {
      setIsWineryPanelOpen(!isWineryPanelOpen);
      setIsPanelOpen(false);
    }
  };

  const closeAllPanels = () => {
    setIsPanelOpen(false);
    setIsWineryPanelOpen(false);
  };

  useEffect(() => {
    if (!isOpen) {
      setIsPanelOpen(false);
      setIsWineryPanelOpen(false);
    }
  }, [isOpen]);

  const handleLinkClick = (path, scrollTarget) => {
    if (location.pathname === path) {
      scroller.scrollTo(scrollTarget, {
        duration: 800,
        smooth: 'easeInOutQuad',
      });
    } else {
      window.location.href = path;
    }
    toggleMenu();
  };

  return (
    <div className={`sidebar-menu ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <RouterLink to="/" onClick={toggleMenu} className="sidebarlogo">
          <img className="img-sidebar" src={burgemmenulogo} alt="logo" />
        </RouterLink>
        <h1>{t('SIDE BY SIDE TO GEORGIAN WINEMAKERS')}</h1>
      </div>

      <div className="sidebar-links">
        {/* Sidebar დახურვის ღილაკი */}
        <div className="sidebarClose" onClick={toggleMenu}>
          <div className="x-button">
            <div className="stick stick1"></div>
            <div className="stick stick2"></div>
          </div>
        </div>

        {/* About us */}
        <ScrollLink to="/about" className="sidebar-product">
          {t('About us')}
        </ScrollLink>

        {/* Product */}
        <div className="sidebar-item">
          <button className="sidebar-product" onClick={() => togglePanel('product')}>
            {t('Product')} <img src={downarrow} alt="dropdown" />
          </button>
          {isPanelOpen && (
            <Panel
              className="sidebar-panel"
              closePanel={closeAllPanels}
              closeSidebarMenu={toggleMenu}
            />
          )}
        </div>

        {/* Winery Products */}
        <div className="sidebar-item">
          <button className="sidebar-product" onClick={() => togglePanel('winery')}>
            {t('Oenological Products')} <img src={downarrow} alt="dropdown" />
          </button>
          {isWineryPanelOpen && (
            <WineryPanel
              className="sidebar-panel"
              closePanel={closeAllPanels}
              closeSidebarMenu={toggleMenu}
            />
          )}
        </div>

        {/* Service */}
        <ScrollLink to="/service" className="sidebar-product">
          {t('Service')}
        </ScrollLink>

        {/* Partners */}
        <RouterLink to="/partners" className="sidebar-link" onClick={toggleMenu}>
          {t('Partners')}
        </RouterLink>
      </div>

      <div className="sidebar-footer">
        {/* სოციალური ქსელები */}
        <div className="sidebar-social">
          <img src={Facebook} alt="Facebook" />
          <a href="https://www.facebook.com/ceenologica" target="_blank" rel="noopener noreferrer">
            Facebook
          </a>
        </div>
        <div className="sidebar-social">
          <img src={Instagram} alt="Instagram" />
          <a href="https://www.instagram.com/ce.enologica?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer">
            Instagram
          </a>
        </div>

        {/* მისამართი და ზარის ღილაკი */}
        <AddressComponent className="sidebar-contact" />
        <CallButton className="Footercall-button" onClick={() => window.location.href = 'tel:+995591090997'}>
          <img src={Phone} alt="Phone" />(+995) 591 09 09 97
        </CallButton>
      </div>
    </div>
  );
};

export default SidebarMenu;